import { ApolloError } from 'apollo-client'
import { useErrorHandler } from 'components/error'
import { useGerarLinkSistemaExternoMutation } from 'graphql/hooks.generated'
import { useCallback, useEffect, useState } from 'react'

import { AtendimentoIframe } from './SistemasExternosAtendimentoView'

export function useLinkSistemaExterno(iframe: AtendimentoIframe | null, cidadaoId: ID) {
  const [url, setUrl] = useState('')
  const handleError = useErrorHandler()
  const [gerarLink, { loading }] = useGerarLinkSistemaExternoMutation()

  const refresh = useCallback(async () => {
    if (!iframe) {
      setUrl('')
      return
    }
    try {
      const { data } = await gerarLink({
        variables: {
          input: {
            providerId: iframe.providerId,
            sistemaExternoId: iframe.id,
            cidadaoId,
          },
        },
      })
      setUrl(data?.gerarLinkSistemaExterno ?? '')
    } catch (e) {
      handleError(e as ApolloError)
    }
  }, [iframe, cidadaoId, gerarLink, handleError])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { url, refresh, loading }
}
